<!--
 * @Author: DY
 * @Date: 2024-12-25 17:55:18
 * @LastEditTime: 2025-02-21 17:31:58
 * @Description: 选择物料
 * @FilePath: \ShiMo_Mobile\src\views\storage\warehouseLocationAdministration\selectMaterials.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="selectMaterials">
            <HeaderNav
                header-title="选择物料"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <div class="currencyTableStyle">
                    <div class="tableHeader">
                        <table>
                            <thead>
                                <tr>
                                    <template v-for="(item, index) in parameter.headerList">
                                        <th :key="`tableHeader_${index}`" :style="{ width: item.width }">
                                            {{ item.name }}
                                        </th>
                                    </template>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tablecontent">
                        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                            <van-list
                                v-model="loading"
                                :finished="finished"
                                finished-text="没有更多了"
                                @load="onLoad"
                            >
                                <table>
                                    <tbody>
                                        <template v-for="(item, index) in listData">
                                            <tr :key="`item_${index}`" :class="{'activeItem': selectIDs.includes(item[parameter.relationKey])}" @click="selectList(item)">
                                                <template v-for="(k, j) in parameter.headerList">
                                                    <td :key="`tableBody_${j}`" :style="{ width: k.width }">
                                                        {{ item[k.code] }}
                                                    </td>
                                                </template>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </van-list>
                        </van-pull-refresh>
                    </div>
                </div>
            </section>
            <van-popup v-model="showMaterialsInfo" class="materialsInfoPopUp">
                <header>物料信息</header>
                <section>
                    <van-cell title="物料代码" :value="materialsInfo.MaterialCode" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                    <van-cell title="短描述" :value="materialsInfo.MaterialShortName" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                    <van-cell title="长描述" :value="materialsInfo.MaterialName" :icon="require('@/assets/images/icons/icon_10@2x.png')"></van-cell>
                    <van-cell title="单位" :value="materialsInfo.Unit" :icon="require('@/assets/images/icons/icon_2@2x.png')"></van-cell>
                    <van-cell title="物资种类" :value="materialsInfo.MaterialType" :icon="require('@/assets/images/icons/icon_13@2x.png')"></van-cell>
                </section>
                <footer class="currencyFooterStyle">
                    <button class="confirm" @click="swiperright">
                        取消选择
                    </button>
                    <button class="confirm" @click="confirmSelection">
                        确认选择
                    </button>
                </footer>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
import { HeaderNav } from '@/components/';
export default {
    name: 'select-materials',
    mixins: [mixin_list],
    components: {
        HeaderNav,
    },
    data() {
        return {
            parameter: {
                sourcePath: '/home',
                type: 'radio',
                listCode: '',
                indexKey: 'PageIndex',
                sizeKey: 'PageSize',
                SearchKey: 'SearchKey',
                pageIndex: 1,
                pageSize: 15,
                initIndex: 1,
                requestUrl: '/basicplatform/tabledata',
                requestType: 'post',
                requestData: {},
                headerList: [],
                tableList: [],
                callbackDataKey: '',
                relationKey: 'id',
            },
            keyVal: '',
            isLoading: false,
            loading: false,
            finished: false,
            listData: [],
            selectIDs: [],
            showMaterialsInfo: false,
            materialsInfo: {},
        };
    },
    filters: {},
    computed: {},
    watch: {},
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        this.initPage();
    },
    mounted() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ name: this.parameter.sourcePath });
        },
        async initPage() {
            this.parameter = Object.assign(this.parameter, this.$route.params);
        },
        onRefresh() {
            this.isLoading = false;
            this.finished = false;
            this.loading = true;
            this.parameter.pageIndex = JSON.parse(JSON.stringify(this.parameter.initIndex));
            this.listData = [];
            this.loadData();
        },
        onLoad() {
            this.loadData();
            this.parameter.pageIndex += 1;
        },
        async loadData() {
            if (this.parameter.requestType === 'post') {
                let requestData = {
                    code: this.parameter.listCode,
                    [this.parameter.indexKey]: this.parameter.isZero ? this.parameter.pageIndex - 1 : this.parameter.pageIndex,
                    [this.parameter.sizeKey]: this.parameter.pageSize,
                    cacheKey: this.cacheKey,
                    [this.parameter.SearchKey]: this.keyVal,
                };
                requestData = Object.assign(requestData, this.parameter.requestData);
                const res = await this.getListData_post(this.parameter.requestUrl, requestData);
                if (requestData[this.parameter.indexKey] === this.parameter.initIndex) {
                    this.listData = res.rows;
                } else {
                    this.listData.push(...res.rows);
                }
                if (res.total <= this.listData.length) {
                    this.finished = true;
                }
            } else if (this.parameter.requestType === 'get') {
                let requestUrl = this.parameter.requestUrl;
                if ((this.keyVal || '') !== '') {
                    if (this.parameter.requestUrl.includes('?')) {
                        requestUrl = `${this.parameter.requestUrl}&${this.parameter.SearchKey}=${this.keyVal}`;
                    } else {
                        requestUrl = `${this.parameter.requestUrl}?${this.parameter.SearchKey}=${this.keyVal}`;
                    }
                }
                const res = await this.getListData_get(requestUrl);
                this.listData = this.parameter.rowsKey && res ? res[this.parameter.rowsKey] : res;
                this.finished = true;
            }
            this.loading = false;
            this.isLoading = false;
        },
        selectList(item) {
            this.materialsInfo = item;
            this.showMaterialsInfo = true;
        },
        confirmSelection() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.parameter.sourcePath,
                params: {
                    [this.parameter.callbackDataKey]: [this.materialsInfo],
                },
            });
        },
        getListData_post(requestUrl, requestData) {
            return this.$axios.$post(`/interfaceApi${requestUrl}`, requestData);
        },
        getListData_get(requestUrl) {
            return this.$axios.$get(`/interfaceApi${requestUrl}`);
        },
    },
};
</script>
<style lang="stylus">
.selectMaterials
    height 100%
    display: flex;
    flex-direction: column;
    section
        flex 1
        height 0
        .currencyTableStyle
            height calc(100% - 44rpx)
    .materialsInfoPopUp
        width 90%
        border-radius 4rpx
        header
            height 50rpx
            font-size 18rpx
            line-height 42rpx
            text-align center
            border-bottom 1px solid #F0F0F0
            background: linear-gradient( 180deg, #FFF4F2 0%, #FFFFFF 100%);
        section
            height: 300rpx
            .van-cell
                display flex
                align-items: center
                border-bottom 1px solid #F0F0F0
                .van-field__left-icon .van-icon,
                    .van-cell__left-icon
                        height 16rpx
                        line-height: 16rpx
                        font-size 16rpx
                        margin-right: 6rpx
                    .van-cell__title
                        width 38%
                        font-size 14rpx
                    .van-cell__value
                        width 52%
</style>
